export default __webpack_public_path__ + "static/media/image-error-unauthorized-dark.ab8debb2.svg";